export const grants = ['create_company', 'edit_company', 'delete_company', 'read_companies', 'create_project']

export default grants
